import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

/* --------------
    TOOLS
---------------*/

import {ImageGridTool} from './tools/ImageGridTool'
Vue.prototype.$imgGridTool = ImageGridTool

import CompanyTool from './tools/CompanyTool'
Vue.prototype.$companyTool = CompanyTool

import AddressTool from './tools/AddressTool'
Vue.prototype.$addressTool = AddressTool

import FormTool from './tools/FormTool'
Vue.prototype.$formTool = FormTool

import PdfTool from './tools/PdfTool'
Vue.prototype.$PdfTool = PdfTool

import ModalTool from './tools/ModalTool'
Vue.prototype.$modal = ModalTool

import SpaceTool from './tools/SpaceTool'
Vue.prototype.$spaceTool = SpaceTool

import StyleTool from './tools/StyleTool'
Vue.prototype.$styleTool = StyleTool

import CryptoTool from './tools/CryptoTool'
Vue.prototype.$crypto = CryptoTool

import LangTextTool from './tools/LangTextTool'
Vue.prototype.$tt = LangTextTool.getText


/* --------------
    PACKAGES
---------------*/

// Toastification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {});

// Dropdown
import DropdownMenu from 'v-dropdown-menu'
import 'v-dropdown-menu/dist/v-dropdown-menu.css'
Vue.use(DropdownMenu)  

// Input phone
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

// Tooltip
import vTitle from 'vuejs-title'
Vue.use(vTitle, {
    maxHeight: '450px',
    bgColor: 'rgb(209 213 219)',
    textColor: '#000'
})

// Lazyload
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
    error: 'https://disticloudfiles.net/img/savinfo/default/img-broken.png',
    loading: 'https://disticloudfiles.net/img/savinfo/default/loading.gif',
})

// Qr Code
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

/* --------------
    LANGUES
---------------*/

async function initI18n() {
    const VueI18n = require('vue-i18n').default
    Vue.use(VueI18n)

    const lang = await CompanyTool.getLang()

    // let i18nMessages = require('@/i18n/i18n').default
    // console.log(i18nMessages);

    // Set Default Langage
    // let defaultLang = navigator.language || navigator.userLanguage
    // if (localStorage.getItem('langage')) {
    //     defaultLang = localStorage.getItem('langage')
    // }

    return new VueI18n({
      locale: lang.lang,
      messages: {[lang.lang]: lang.contenu},
      silentTranslationWarn: true
    });
}

/* --------------
    TEMPLATE
---------------*/

function initTemplate() {
    // let companyTemplateFile = companyFileConf ? companyFileConf.style.template : 'SavTemplate'
    let companyTemplateFile = 'SavTemplate'
    let companyDirectory = CompanyTool.confFile() ? CompanyTool.confFile().overwrite_folder : 'default'

    try {
        const templateFile = require('./companies/' + companyDirectory + '/views/template/' + companyTemplateFile)
        Vue.component('sav-template', templateFile.default)
    } catch (e) {
        console.warn('Template not found - template: ' + companyTemplateFile + ', directory: ' + companyDirectory)
        Vue.component('sav-template', require('./companies/default/views/template/SavTemplate').default)
    }
}

/* --------------
    COMPONENTS
---------------*/

function initProjectComponents() {
    let companyDirectory = CompanyTool.confFile() ? CompanyTool.confFile().overwrite_folder : 'default'
    let defaultComponents = require('./companies/default/components/conf.js').default
    if (companyDirectory != 'default') {
        let overwriteComponents = require('./companies/' + companyDirectory + '/components/conf.js').default
    
        Object.entries(overwriteComponents).forEach(([name, component]) => {
            defaultComponents[name] = component
        })
    }
    Object.entries(defaultComponents).forEach(([name, component]) => Vue.component(name, component))
}

/* --------------
    START
---------------*/

async function initApp() {
    // Get Config File
    await SpaceTool.setLocalStorage()

    // Init i18n
    const i18n = await initI18n()

    // Init template
    initTemplate()

    // Init project components
    initProjectComponents()

    // Get translated texts api2
    await LangTextTool.init()

    // Router
    let router = require('./router/router.js').default;

    new Vue({
        el: '#app',
        i18n,
        router,
        components: { App },
        template: '<App/>'
    })
}

initApp()



// WEBPACK FOOTER //
// ./src/main.js